<template>
  <div class="upload-content">
    <div class="clearfix mb-3">
      <div class="float-end d-flex">
        <!-- TODO: Change this button position beside McWizard -->
        <McButton
          class="upload-content__btn-next"
          :text="$t('global.next')"
          icon="icon-outline_arrow-right"
          iconPosition="right"
          :disabled="isDisableNextBtn"
          @click="$emit('upload-file')"
        />
      </div>
    </div>
    <b-card class="upload-card">
      <b-row>
        <b-col cols="4">
          <AttachmentField
            ref="attachment-field-ref"
            :selectedUserGroup="hasUserGroupFeature ? fullObjects.userGroup : null"
            @update:isDisableNextBtn="isDisableNextBtn = $event"
            @selectFile="handleSelectFile"
          />
        </b-col>
        <b-col cols="8" class="d-flex">
          <GuideCard />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-if="hasUserGroupFeature"
      id="modal-user-group"
      title="Pilih Grup Pengguna"
      size="md"
      centered
      hide-head-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <FormulateForm v-model="formValues">
        <FormulateInput
          type="value-help-v2"
          name="userGroupId"
          label="Pilih Grup Pengguna untuk melanjutkan"
          trackBy="id"
          placeholder="Pilih Grup Pengguna"
          :displayedBy="'name'"
          :fullObject.sync="fullObjects.userGroup"
          :listGetter="userGroupQuery"
          :multiple="false"
          :tableFields="userGroupTableFields"
          :modalTitle="'Pilih Grup Pengguna'"
          :help="true"
          validation="required"
          validation-behavior="live"
        />
      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <div class="d-flex justify-content-end gap-2">
          <McButton
            variant="secondary"
            text="Tutup"
            @click="handleCancel(cancel)"
          />
          <McButton
            text="Pilih Dokumen"
            :disabled="!formValues.userGroupId"
            @click="handleConfirmUserGroup"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import AttachmentField from '../components/AttachmentField'
import GuideCard from '../components/GuideCard'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    McButton,
    AttachmentField,
    GuideCard,
  },
  mixins: [Helper],
  emits: ['upload-file'],
  data() {
    return {
      isDisableNextBtn: true,
      formValues: {
        userGroupId: null,
      },
      fullObjects: {
        userGroup: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    hasUserGroupFeature() {
      const hasScope = this.hasAccessAll(['tms-user-group:read'])
      const isSuperUser = this.isSuperUser()
      
      return hasScope && isSuperUser
    },
    userGroupTableFields() {
      return [
        {
          label: 'Grup Pengguna',
          key: 'name',
          isSortable: false,
        },
        {
          label: 'Grup Kendaraan',
          key: 'vgroups',
          isSortable: false,
          formatter: (value) => {
            return value?.length != null ? (value.length === 0 ? 'Semua Grup Kendaraan' : value.length) : '-'
          },
        },
      ]
    },
  },
  methods: {
    handleSelectFile() {
      if (this.hasUserGroupFeature) {
        this.$bvModal.show('modal-user-group')
      } else {
        this.$refs['attachment-field-ref'].openFileDialog()
      }
    },
    handleCancel(cancel) {
      this.formValues.userGroupId = null
      this.fullObjects.userGroup = null

      cancel()
    },
    handleConfirmUserGroup() {
      if (!this.formValues.userGroupId || !this.fullObjects.userGroup) {
        this.$mcToast.warning('Grup Pengguna wajib diisi')
        return
      }
      
      this.$bvModal.hide('modal-user-group')
      this.$refs['attachment-field-ref'].openFileDialog()
    },
    async userGroupQuery(opts) {
      let result = {}
      const filter = {
        pagination: {
          page: opts?.page,
          show: opts?.limit,
        },
        search: opts?.search,
      }

      const res = await this.$apollo.query({
        query: GET_USER_GROUP,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
          },
        },
      })

      const ugroups = res.data.ugroups.ugroups

      result = {
        metadata: {
          total_count: ugroups.pagination.total,
          page: ugroups.pagination.page,
        },
        data: {
          paginated_result: ugroups.data,
        },
      }

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-card {
  .card-body {
    padding: 24px;
  }
}
</style>
